import { render, staticRenderFns } from "./carregando.vue?vue&type=template&id=8f7107ce&scoped=true&"
import script from "./carregando.vue?vue&type=script&lang=js&"
export * from "./carregando.vue?vue&type=script&lang=js&"
import style0 from "./carregando.vue?vue&type=style&index=0&id=8f7107ce&scoped=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7107ce",
  null
  
)

export default component.exports